export const dataProperties = {
  businessName: 'businessName',
  logo: 'logo',
};

export const businessNameMaxCount = 90;
